// src/components/GooglePlaceInput.js

import React, { useEffect, useState } from "react";

export function GooglePlaceInput({ value, onChange, disabled, error }) {
  const [localValue, setLocalValue] = useState(value || "");

  useEffect(() => {
    setLocalValue(value || "");
  }, [value]);

  const handleBlur = () => {
    if (disabled) return;
    onChange(localValue || "");
  };

  const baseInputStyle = {
    width: "100%",
    padding: "5px 7px",
    marginTop: 2,
    borderRadius: 6,
    border: "1px solid #4b5563",
    background: "#020617",
    color: disabled ? "#6b7280" : "#e5e7eb",
    fontSize: 13,
    boxSizing: "border-box",
    cursor: disabled ? "not-allowed" : "text",
  };

  return (
    <div style={{ marginTop: 6, marginBottom: 6 }}>
      <label style={{ fontSize: 13, display: "block" }}>
        Place of Birth:
        <input
          id="birth-place"
          placeholder="Your City of birth"
          value={localValue}
          onChange={(e) => setLocalValue(e.target.value)}
          onBlur={handleBlur}
          style={baseInputStyle}
          disabled={disabled}
        />
      </label>
      <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 2 }}>
        {disabled
          ? "Using latitude / longitude mode. City & country are disabled."
          : "You can type city and country (e.g., Mumbai, India). Latitude / longitude will be auto-resolved."}
      </div>
      {error && (
        <div style={{ fontSize: 11, color: "#f97373", marginTop: 2 }}>
          {error}
        </div>
      )}
    </div>
  );
}
